<template>
  <div class="SocialProof">
    <div class="container">
      <div class="SocialProofContent">
        <h3>
          Land a six-figure job in one of the top
          companies.
        </h3>
        <div class="SocialProofLogos">
          <img src="../assets/img/amazon.svg" alt="amazon" />
          <img src="../assets/img/facebook.svg" alt="facebook" />
          <img src="../assets/img/google.svg" alt="google" />
          <img src="../assets/img/microsoft.svg" alt="microsoft" />
          <img src="../assets/img/uber.svg" alt="uber" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialProof",
};
</script>

<style lang="scss" scoped>
.SocialProof {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 150px;
  padding: 100px 0;
  .SocialProofContent {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h3 {
    margin-bottom: 100px;
    color: $color-grey;
    font-weight: 400;
    font-size: 21px;
  }
  img {
    height: 40px;
    margin: 0 40px;
  }
}

.SocialProofLogos {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
@media screen and (max-width: 1200px) {
  .SocialProofContent {
    .SocialProofLogos {
      img {
        height: 35px;
        margin: 0 30px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .SocialProof {
    .container {
      max-width: 100%;
    }
    .SocialProofContent {
      .SocialProofLogos {
        width: 90%;
        flex-wrap: wrap;
        justify-content: center;
        img {
          margin-bottom: 50px;
        }
      }
    }
  }
}

@media screen and (max-width: 650px) {
  .SocialProof {
    display: none;
  }

  .SocialProofContent {
    h3 {
      text-align: center;
      line-height: 1.5;
    }
  }
}
</style>
